<template>
  <withTopNav :leftText="detail.activityConfigName" class="secretBonus" fixed>
    <div class="banner">
      <p>Hora de registo : {{ dayjs(info.registerTime).local().format('YYYY-MM-DD') }}</p>
    </div>

    <div class="tabs">
      <div class="scrollList">
        <template v-if="tabs.length > 5">
          <span
            class="prev h-full absolute-lt-0 w-8"
            v-if="tabIndex > 0"
            @click="showTabByIndex(tabIndex - 1)"
          ></span>
          <span
            class="next h-full absolute-rt-0 w-8"
            v-if="tabIndex < tabs.length - 1"
            @click="showTabByIndex(tabIndex + 1)"
          ></span>
        </template>

        <div class="content" ref="tabRef">
          <div
            :class="['item', tabIndex == i && 'cur', tab.cln]"
            v-for="(tab, i) in tabs"
            :key="tab.title"
            @click="showTabByIndex(i)"
          >
            <span>{{ tab.title }}</span>
          </div>
        </div>
      </div>

      <div class="mx-4 rounded-8 p-4 bg-gradient-to-b from-[rgba(44,121,82,0.7)] to-[rgba(44,121,82,0)] relative">
        <div class="pl-[30px] bgs-[url('@a/views/_Activities/secretBonus/images/ico1.png'),0_0,24px] leading-[24px]">
          <p class="text-13">Depósito total de {{ info.currentDay }} dia(s)：</p>
          <p class="text-15 text-[#0BCF33] font-[600]">R$ {{ formatter().format(info.totalDepositAmount) }}</p>
        </div>

        <div
          class="flex justify-between pl-[30px] bgs-[url('@a/views/_Activities/secretBonus/images/ico2.png'),0_0,24px] mt-3 leading-[24px]">
          <p class="text-13">Bónus Misterioso：</p>
          <p class="text-15 text-[#0BCF33] font-[600]">Maior R$ {{ formatter().format(info.showMaxAmount) }}</p>
        </div>

        <div
          class="primaryBtn mt-4 !text-13"
          @click="receber"
          v-if="curRewardDay.status == 'Awarded'">
          Receber
        </div>
        <template v-else>
          <div class="primaryBtn_transparent mt-4 !text-13 !text-white/50">
            {{
              curRewardDay.status == 'Received' ?
                `Já recebeu R$${formatter().format(curRewardDay.rewardAmount)}` :
                curRewardDay.status == 'Expired' ?
                 'O bônus expirou':
                  +curRewardDay.rewardDay > +info.currentDay ?
                   `Pode reivindicar o prêmio após ${curRewardDay.rewardDay - info.currentDay} dia(s)` :
                   'No disponible para recogida'
                }}
          </div>
        </template>

        <div
          class="primaryBtn !w-22.5 !h-8 !tracking-[0] absolute-rt-4"
          @click="$router.push('/deposito')"
        >
          Depósito
        </div>
      </div>
    </div>

    <div class="m-4">
      <DataTable :columns="columns" :data="tableData" round />
    </div>

    <ActivityDesc
      class="m-4"
      title="Descricão da Atividade"
      :list="descList"
    />
  </withTopNav>
</template>

<script setup lang="tsx">
import withTopNav from "@/layouts/withTopNav.vue";
import ActivityDesc from "@a/components/ActivityDesc/index.vue";
import DataTable from "@a/components/DataTable/index.vue";
// import ScrollList from '@a/components/ScrollList/index.vue'
import showPopup from "@/themes/theme_a/components/showPopup";
// import CashTip from './cashTip.vue'
// import GgcTip from './ggcTip.vue'
import { useActivity } from '@/hooks/useActivity'
import { getSecretBonusInfo, getSecretBonusInfoWithoutAuth } from '@/api/secretBonus'
// import { ACTIVITY_TYPES } from "@/consts";
// import type { iFlowType } from "@/types/index";
import { formatter } from '@/utils'
import dayjs from 'dayjs'
import Tip from '@a/components/Tip/index.vue'

const tabIndex = ref(0);
const tabRef = useTemplateRef<HTMLDivElement>("tabRef");

const showTabByIndex = (index: number) => {
  console.log(index);
  tabIndex.value = index;
  const spans = tabRef.value?.querySelectorAll(".item span");
  spans?.[index]?.scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "center",
  });
};

const columns = [
  {
    title: "Depósito",
    key: "deposit",
    render: (row: any) => <div class="text-13 flex-center size-full">{row.depositAmount}</div>,
  },
  {
    title: 'Prêmio',
    key: 'bonus',
    render: (row: any) => <div class="text-11 pt-8 pb-2 bgs-[url('@a/views/_Activities/secretBonus/images/ico3.png'),center_6px,24px] text-[white]/75">Valor: R$ {row.showMinAmount} - {row.showMaxAmount}</div>
  }
]

const tabs = computed(() => {
  return info.value.rewardDayList.map((item) => ({
    title: `DIA ${item.rewardDay}`,
    status: item.status,
    cln: getStatusCN(item.status, +item.rewardDay, +info.value.currentDay),
  }))
})

const activityId = useRoute().query.activityId as string
const activity = useActivity(activityId, {
  getInfo: getSecretBonusInfo,
  getInfoWithoutAuth: getSecretBonusInfoWithoutAuth
})

const detail = computed(() => activity.data.value.detail)
const descList = computed(() => activity.data.value.descList)
const info = computed(() => activity.data.value.info || {
  registerTime: '',
  joinTime: '',
  scope: '',
  showMaxAmount: 0,
  currentDay: 0,
  rewardDayList: []
})

watch(info, () => {
  info.value.rewardDayList.some((item, i) => {
    tabIndex.value = i
    if (item.rewardDay >= info.value.currentDay) {
      return true
    }
  })
}, {
  once: true
})

const curRewardDay = computed(() => {
  return info.value.rewardDayList[tabIndex.value] || {
      rewardDay: 0,
      status: '',
      depositAmount: 0,
      rewardId: 0,
      rewardAmount: 0,
      gearlConfigs: []
    }
})

const tableData = computed(() => {
  return curRewardDay.value?.gearlConfigs.map((item) => ({
    depositAmount: formatter().format(item.depositAmount),
    showMinAmount: formatter().format(item.showMinAmount),
    showMaxAmount: formatter().format(item.showMaxAmount),
  })) || []
})

// enum Status {
//   gray_whole = 'gray_whole',
//   gray_opened = 'gray_opened',
//   color_opened = 'color_opened',
//   color_opened_half = 'color_opened_half',
//   color_opened_full = 'color_opened_full'
// }

const getStatusCN = (status: string, day: number, curDay: number) => {
  let res = day < curDay ? 'gray' : 'color'

  switch (status) {
    case 'Expired':
    case 'Unarchived':
      res += '_whole'
      break
    case 'Awarded':
      if (day <= curDay) {
        res += '_opened_half'
      } else {
        res += '_whole'
      }
      break
    case 'Received':
      res += '_opened'
  }

  return res
}

const receber = async () => {
  const onSuccess = async () => {
    const res = await activity.getDetail(activityId, getSecretBonusInfo)
    Object.assign(activity.data.value.info, res)
  }

  showPopup(<Tip
    amount={curRewardDay.value.rewardAmount}
    type='bonus'
    rewardId={curRewardDay.value.rewardId}
    flowType='MysteryBonusReward'
    activityId={activityId}
    onSuccess={onSuccess}
  />)
}
</script>

<style lang="scss">
.secretBonus {
  .banner {
    @apply h-[254px] text-center flex flex-col justify-end bgs-[url('@a/assets/images/bg_bonus_banner.png')];

    p {
      @apply text-13 leading-[24px] font-[600] tracking-[0.38px];
    }
  }

  .gray_whole {
    background: url("./images/s1.png") no-repeat center 0 / 24px;
  }
  .gray_opened {
    background: url("./images/s2.png") no-repeat center 0 / 24px;
  }
  .color_opened {
    background: url("./images/s3.png") no-repeat center 0 / 24px;
  }
  .color_opened_half {
    background: url("./images/s4.png") no-repeat center 0 / 24px;
  }
  .color_whole {
    background: url("./images/s5.png") no-repeat center 0 / 24px;
  }

  .tabs {
    @apply relative mt-4;

    .scrollList {
      @apply relative h-[82px] overflow-y-hidden;
    }

    .content {
      @apply pt-2 mx-4 text-center flex overflow-x-auto overflow-y-hidden text-13 text-[#fff]/50 snap-mandatory snap-x;
    }

    &::before {
      @apply content-[''] bg-gradient-to-b from-[rgba(44,121,82,0.7)] to-[rgba(44,121,82,0)] h-15 absolute-[0_0_auto] rounded-t-8;
    }

    .prev {
      background: url("./images/prev.png") no-repeat center / 16px;
      z-index: 99;
    }

    .next {
      background: url("./images/next.png") no-repeat center / 16px;
      z-index: 99;
    }

    .item {
      @apply pt-[28px] w-[20%] flex-initial shrink-0 snap-start;
      // height: 63px;
      overflow-y: hidden;

      span {
        @apply font-[600];
      }
    }

    .cur {
      position: relative;
      color: var(--theme-primary);
      height: 80px;

      span {
        border-bottom: 2px solid var(--theme-primary);
        display: block;
        margin: 0 2px;
        padding-bottom: 4px;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        right: 0;
        width: 12px;
        height: 12px;
        background: rgba(44, 121, 82, 0.7);
        transform: rotate(45deg);
        margin-left: -6px;
      }
    }
  }
}
</style>
